// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsn-control.lsn-dropdown {
  position: relative;
  width: 100%;
}
.lsn-control.lsn-dropdown input.drop-down-value-holder {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  outline: none;
  border: 0 !important;
  box-shadow: none;
  background: none;
  color: transparent;
}
.lsn-control.lsn-dropdown div.dropdown {
  border-radius: 0;
  border: 0;
  background: none;
  font-size: var(--main-font-size-control);
}
.lsn-control.lsn-dropdown div.dropdown[open] svg path {
  fill: var(--main-primary-color) !important;
}
.lsn-control.lsn-dropdown div.dropdown[open] input {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.lsn-control.lsn-dropdown div.dropdown input {
  border-radius: var(--main-control-border-radius) !important;
  border: var(--main-border-width) solid var(--main-border-color);
  font-size: var(--main-font-size-control);
  line-height: calc(var(--main-font-size-control) * 1.5);
  background-color: var(--main-control-bg-color);
}
.lsn-control.lsn-dropdown div.dropdown input:active,
.lsn-control.lsn-dropdown div.dropdown input:focus {
  border: var(--main-border-width) solid var(--main-primary-color);
  box-shadow: 0 0 3px 0 var(--main-primary-color);
}
.lsn-control.lsn-dropdown div.dropdown .dropdown-selector {
  display: block;
  padding: 0;
  height: auto;
}
.lsn-control.lsn-dropdown div.dropdown .dropdown-selector .dropdown-selector-search {
  position: static;
}
.lsn-control.lsn-dropdown div.dropdown .dropdown-selector .dropdown-selector-search input {
  margin: 0;
  font-size: var(--main-font-size-control);
  line-height: calc(var(--main-font-size-control) * 1.5);
  height: auto;
  cursor: pointer;
}
.lsn-control.lsn-dropdown div.dropdown .dropdown-selector .dropdown-selector-value {
  position: absolute;
  top: 50%;
  left: 0.5rem;
  bottom: auto;
  transform: translateY(-50%);
  display: inline;
}
.lsn-control.lsn-dropdown div.dropdown .dropdown-selector-placeholder {
  position: absolute;
  top: 50%;
  left: 0.5rem;
  bottom: auto;
  transform: translateY(-50%);
  display: inline;
  font-size: var(--main-font-size-control-placeholder);
  line-height: calc(var(--main-font-size-control-placeholder) * 1.5);
}
.lsn-control.lsn-dropdown div.dropdown .dropdown-arrow {
  right: 8px;
}
.lsn-control.lsn-dropdown div.dropdown .dropdown-arrow i {
  transition: transform 1s;
}
.lsn-control.lsn-dropdown div.dropdown .dropdown-arrow i.opened {
  transform: rotate3d(1, 1, 0, 180deg) rotate3d(0, 0, 1, 90deg);
}
.lsn-control.lsn-dropdown div.dropdown .dropdown-selector-value {
  height: auto;
  min-height: auto;
  font-size: var(--main-font-size-control);
  line-height: calc(var(--main-font-size-control) * 1.5);
  color: inherit;
}
.lsn-control.lsn-dropdown div.dropdown input {
  border-radius: 0;
}
.lsn-control.lsn-dropdown span.lsn-dropdown-content-new {
  border-radius: 0;
  margin-top: 0;
  border: var(--main-border-width) solid var(--main-primary-color);
  text-align: left;
  z-index: 11;
  background-color: var(--main-control-bg-color);
  color: inherit;
  overflow-y: auto;
}
.lsn-control.lsn-dropdown span.lsn-dropdown-content-new .dropdown-option {
  background-color: transparent;
  min-height: 35px;
  font-size: var(--main-font-size-control);
  padding: 0.3rem 0 0.3rem 1.5rem;
  -webkit-tap-highlight-color: var(--main-black);
  box-sizing: border-box;
  cursor: pointer;
}
.lsn-control.lsn-dropdown span.lsn-dropdown-content-new .dropdown-option.focused,
.lsn-control.lsn-dropdown span.lsn-dropdown-content-new .dropdown-option:hover {
  background-color: color-mix(in srgb, var(--main-primary-color), var(--main-control-bg-color));
}
.lsn-control.lsn-dropdown span.lsn-dropdown-content-new .dropdown-option.selected {
  background-color: color-mix(in srgb, var(--main-primary-color), var(--main-control-bg-color) 30%);
  color: var(--main-text-color);
  position: relative;
}
.lsn-control.lsn-dropdown span.lsn-dropdown-content-new .dropdown-option.selected::before {
  content: '\\f058';
  font-family: 'Font Awesome 5 Pro';
  font-weight: 900;
  position: absolute;
  left: 0.15rem;
  color: var(--main-white);
}
.lsn-control.lsn-dropdown .control-error-wrapper {
  position: relative;
}
.lsn-control.lsn-dropdown .control-error-wrapper .lsn-form-control-error-message {
  position: absolute;
  left: 0;
  right: 0;
}
.lsn-control.lsn-dropdown .dropdown-selector-placeholder {
  color: var(--main-control-placeholder-color);
}
.lsn-control.lsn-dropdown.has-error div.dropdown input {
  border-color: var(--main-red);
}
.lsn-control.lsn-dropdown.has-error div.dropdown input:active,
.lsn-control.lsn-dropdown.has-error div.dropdown input:focus {
  border: 1px solid var(--main-red);
  box-shadow: 0 0 3px 0 var(--main-red);
}
.lsn-control.lsn-dropdown.has-error div.dropdown .dropdown-selector-placeholder {
  color: var(--main-red);
}
.lsn-control.lsn-dropdown.has-error div.dropdown svg path {
  fill: var(--main-red) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/controls/Form/components/DropdownField/DropdownField.less"],"names":[],"mappings":"AAAA;EASE,kBAAA;EACA,WAAA;AAPF;AAHA;EAaI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAPJ;AAdA;EAyBI,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,wCAAA;AARJ;AAWI;EAEI,0CAAA;AAVR;AAQI;EAMI,uCAAA;EACA,wCAAA;AAXR;AA3BA;EA2CM,2DAAA;EAEA,+DAAA;EACA,wCAAA;EACA,sDAAA;EACA,8CAAA;AAdN;AAgBM;;EAEE,gEAAA;EACA,+CAAA;AAdR;AAvCA;EA0DM,cAAA;EACA,UAAA;EACA,YAAA;AAhBN;AA5CA;EA+DQ,gBAAA;AAhBR;AA/CA;EAkEU,SAAA;EACA,wCAAA;EACA,sDAAA;EACA,YAAA;EACA,eAAA;AAhBV;AAtDA;EA2EQ,kBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,2BAAA;EACA,eAAA;AAlBR;AA9DA;EAqFM,kBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,2BAAA;EACA,eAAA;EACA,oDAAA;EACA,kEAAA;AApBN;AAxEA;EAgGM,UAAA;AArBN;AA3EA;EAmGQ,wBAAA;AArBR;AAuBQ;EACE,6DAAA;AArBV;AAjFA;EA4GM,YAAA;EACA,gBAAA;EACA,wCAAA;EACA,sDAAA;EACA,cAAA;AAxBN;AAxFA;EAoHM,gBAAA;AAzBN;AA3FA;EAyHI,gBAAA;EACA,aAAA;EACA,gEAAA;EACA,gBAAA;EACA,WAAA;EACA,8CAAA;EACA,cAAA;EACA,gBAAA;AA3BJ;AArGA;EAmIM,6BAAA;EACA,gBAAA;EACA,wCAAA;EACA,+BAAA;EACA,8CAAA;EACA,sBAAA;EACA,eAAA;AA3BN;AA6BM;;EAEE,6FAAA;AA3BR;AA8BM;EACE,iGAAA;EACA,6BAAA;EACA,kBAAA;AA5BR;AA8BQ;EACE,gBAAA;EACA,iCAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,wBAAA;AA5BV;AA/HA;EAkKI,kBAAA;AAhCJ;AAlIA;EAqKM,kBAAA;EACA,OAAA;EACA,QAAA;AAhCN;AAvIA;EA4KI,4CAAA;AAlCJ;AAqCE;EAEI,6BAAA;AApCN;AAsCM;;EAEE,iCAAA;EACA,qCAAA;AApCR;AA6BE;EAYI,sBAAA;AAtCN;AA0BE;EAgBI,gCAAA;AAvCN","sourcesContent":[".lsn-control.lsn-dropdown {\n  @varColorActive: var(--main-primary-color);\n  @varColorError: var(--main-red);\n  @varColorBorder: var(--main-border-color);\n  @varColorBorderError: var(--main-red);\n  @varBg: var(--main-control-bg-color);\n  @varText: var(--main-text-color);\n  @varPlaceholder: var(--main-control-placeholder-color);\n\n  position: relative;\n  width: 100%;\n\n  input.drop-down-value-holder {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    outline: none;\n    border: 0 !important;\n    box-shadow: none;\n    background: none;\n    color: transparent;\n  }\n\n  div.dropdown {\n    border-radius: 0;\n    border: 0;\n    background: none;\n    font-size: var(--main-font-size-control);\n    ;\n\n    &[open] {\n      svg path {\n        fill: @varColorActive !important;\n      }\n\n      input {\n        border-bottom-left-radius: 0 !important;\n        border-bottom-right-radius: 0 !important;\n      }\n    }\n\n    input {\n      border-radius: var(--main-control-border-radius) !important;\n      // padding: 0;\n      border: var(--main-border-width) solid var(--main-border-color);\n      font-size: var(--main-font-size-control);\n      line-height: calc(var(--main-font-size-control) * 1.5);\n      background-color: @varBg;\n\n      &:active,\n      &:focus {\n        border: var(--main-border-width) solid @varColorActive;\n        box-shadow: 0 0 3px 0 @varColorActive;\n      }\n    }\n\n    .dropdown-selector {\n      display: block;\n      padding: 0;\n      height: auto;\n\n      .dropdown-selector-search {\n        position: static;\n\n        input {\n          margin: 0;\n          font-size: var(--main-font-size-control);\n          line-height: calc(var(--main-font-size-control) * 1.5);\n          height: auto;\n          cursor: pointer;\n        }\n      }\n\n      .dropdown-selector-value {\n        position: absolute;\n        top: 50%;\n        left: .5rem;\n        bottom: auto;\n        transform: translateY(-50%);\n        display: inline;\n      }\n    }\n\n    .dropdown-selector-placeholder {\n      position: absolute;\n      top: 50%;\n      left: .5rem;\n      bottom: auto;\n      transform: translateY(-50%);\n      display: inline;\n      font-size: var(--main-font-size-control-placeholder);\n      line-height: calc(var(--main-font-size-control-placeholder) * 1.5);\n    }\n\n    .dropdown-arrow {\n      right: 8px;\n\n      i {\n        transition: transform 1s;\n\n        &.opened {\n          transform: rotate3d(1, 1, 0, 180deg) rotate3d(0, 0, 1, 90deg)\n        }\n      }\n    }\n\n    .dropdown-selector-value {\n      height: auto;\n      min-height: auto;\n      font-size: var(--main-font-size-control);\n      line-height: calc(var(--main-font-size-control) * 1.5);\n      color: inherit;\n    }\n\n    input {\n      border-radius: 0;\n    }\n  }\n\n  span.lsn-dropdown-content-new {\n    border-radius: 0;\n    margin-top: 0;\n    border: var(--main-border-width) solid @varColorActive;\n    text-align: left;\n    z-index: 11;\n    background-color: @varBg;\n    color: inherit;\n    overflow-y: auto;\n\n    .dropdown-option {\n      background-color: transparent;\n      min-height: 35px;\n      font-size: var(--main-font-size-control);\n      padding: .3rem 0 .3rem 1.5rem;\n      -webkit-tap-highlight-color: var(--main-black);\n      box-sizing: border-box;\n      cursor: pointer;\n\n      &.focused,\n      &:hover {\n        background-color: color-mix(in srgb, @varColorActive, @varBg);\n      }\n\n      &.selected {\n        background-color: color-mix(in srgb, @varColorActive, @varBg 30%);\n        color: @varText;\n        position: relative;\n\n        &::before {\n          content: '\\f058';\n          font-family: 'Font Awesome 5 Pro';\n          font-weight: 900;\n          position: absolute;\n          left: .15rem;\n          color: var(--main-white);\n        }\n      }\n    }\n  }\n\n  .control-error-wrapper {\n    position: relative;\n\n    .lsn-form-control-error-message {\n      position: absolute;\n      left: 0;\n      right: 0;\n    }\n  }\n\n  .dropdown-selector-placeholder {\n    color: @varPlaceholder;\n  }\n\n  &.has-error div.dropdown {\n    input {\n      border-color: @varColorError;\n\n      &:active,\n      &:focus {\n        border: 1px solid @varColorError;\n        box-shadow: 0 0 3px 0 @varColorError;\n      }\n    }\n\n    .dropdown-selector-placeholder {\n      color: @varColorError;\n    }\n\n    svg path {\n      fill: @varColorError !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
